import { render, staticRenderFns } from "./ImgShow.vue?vue&type=template&id=f5676546&"
import script from "./ImgShow.vue?vue&type=script&lang=js&"
export * from "./ImgShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports